import axiosInstance from './axiosConfig';
import { ApiResponse } from './generalService';

export type ExportSource = 'api-service' | 'legacy-forms';

export interface ExportBatchRequest {
  source: ExportSource;
  limit?: number;
  cursor?: string | null;
  since?: string;
  confirm?: 'RUN';
}

export interface ExportBatchReport {
  source: ExportSource;
  fetched: number;
  skippedDuplicates: number;
  skippedNotSubmitted: number;
  published: number;
  failed: number;
  nextCursor: string | null;
  droppedFields: string[];
  dryRun: boolean;
  attemptId: string;
}

export const exportNewVisitFormsBatch = (body: ExportBatchRequest) =>
  axiosInstance.post<ApiResponse<ExportBatchReport>>(
    '/admin/exports/new-visit-forms',
    body
  );
